var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.header.classes},[_c('v-simple-checkbox',{attrs:{"disabled":_vm.disabled,"value":_vm.header.valueParser ? _vm.header.valueParser(_vm.value, _vm.props.item) : _vm.value},on:{"input":_vm.callAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }